import axios from "axios";
import { saveAs } from "file-saver";
import blobApi from "@/api/blobApi";
// import commonApi from "@/api/commonApi.js";
// import attachmentApi from "@/api/attachmentApi.js";
// import b64toBlob from "b64-to-blob";

const baseURL = process.env.VUE_APP_APIURL;

const imagesTypesSupported = ["image/jpeg", "image/png"];

function readFile(file) {
  // Create a blob field
  let blob;
  const URL = window.URL || window.webkitURL;
  if (URL && URL.createObjectURL) {
    blob = URL.createObjectURL(file);
  }

  axios.defaults.baseURL = "";
  return new Promise((resolve, reject) => {
    axios.get(blob, { responseType: "blob" }).then(
      (response) => {
        const reader = new FileReader() as any;
        reader.readAsDataURL(response.data);
        reader.onloadend = function () {
          const dataOnly = reader.result.substring(
            reader.result.indexOf(",") + 1,
            reader.result.length
          );
          axios.defaults.baseURL = baseURL;
          resolve(dataOnly);
        };
      },
      (error) => {
        reject(error);
      }
    );
  });
}

function saveFile(response, fileName?, applicationType?) {
  applicationType =
    applicationType ||
    response.type ||
    response.contentType ||
    response.data.type ||
    response.data.contentType;
  fileName =
    fileName || response.name || response.fileName || response.data.name;
  const blob = response.blob || response.data || response || response.data.blob;

  const data = new Blob([blob], {
    type: applicationType,
  });

  if (navigator.userAgent.match("CriOS")) {
    const fileUrl = URL.createObjectURL(data);
    window.open(fileUrl);
  } else {
    saveAs(data, fileName);
  }
}

async function clickOnFile(attachment: any, attachments: any) {
  if (attachment.base64) {
    // const blob = b64toBlob(attachment.base64, attachment.contentType);
    // return await commonApi
    //   .downloadOrOpen(
    //     {
    //       data: {
    //         contentType: attachment.contentType,
    //         name: attachment.fileName,
    //         guid: attachment.guid,
    //         blob: blob
    //       }
    //     },
    //     attachments
    //   )
    //   .then(res => {
    //     //if res then it is image if not downloade file
    //     if (res) {
    //       //open modal and show image
    //       return res;
    //     }
    //   });
  } else {
    return await blobApi.downloadBlob(attachment).then(async (res) => {
      res.guid = attachment.guid;
      return await downloadOrOpen(res, attachments).then((res) => {
        //if res then it is image if not downloade file
        if (res) {
          //open modal and show image
          return res;
        }
      });
    });
  }
}

function getFileIcon(extension: string) {
  const iocn = {
    ".html": "mdi-language-html5",
    ".js": "mdi-nodejs",
    ".json": "mdi-json",
    ".md": "mdi-markdown",
    ".pdf": "mdi-file-pdf-box",
    ".png": "mdi-file-image",
    ".jpg": "mdi-file-image",
    ".jpeg": "mdi-file-image",
    ".txt": "mdi-file-document-outline",
    ".xls": "mdi-file-excel",
    ".xlsx": "mdi-file-excel-outline",
    ".doc": "mdi-file-word",
    ".docx": "mdi-file-word-outline",
  };

  //Get icon name by extension
  const icon = iocn[extension];
  //Return icon from list or default
  return icon || "mdi-file-document";
}

function isImage(contentType: any) {
  return imagesTypesSupported.includes(contentType);
}

async function downloadOrOpen(res: any, files: any) {
  if (files.length === 0) {
    saveFile(res);
    return;
  }

  if (isImage(res.contentType)) {
    if (res.guid !== undefined) {
      files = files.filter((files) => {
        return (
          isImage(files.contentType) &&
          files.status === 0 &&
          files.guid !== res.guid
        );
      });
      return [...[res], ...files];
    }
  } else {
    saveFile(res);
  }
}

// export function saveBlob(blob, fileName) {
//   saveAs(blob, fileName);
// }

// export default { readFile, saveFile, clickOnFile };

export { readFile, clickOnFile, saveFile, isImage, getFileIcon };
